import { useEffect, useState } from "react";

import { getPresignedUrl } from "../utils/fetch";

export default function usePresignedUrl(documentCategory, key) {
  const isExternalKey =
    typeof key === "string" &&
    (key.startsWith("http://") || key.startsWith("https://"));
  const [presignedUrl, setPresignedUrl] = useState(
    isExternalKey ? key : null
  );

  useEffect(() => {
    let cancelled = false;
    if (!key || isExternalKey) {
      return undefined;
    }
    setPresignedUrl(null);
    getPresignedUrl({ documentCategory, key }).then((url) => {
      if (!cancelled && url) {
        setPresignedUrl(url.toString());
      }
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentCategory, key]);

  return presignedUrl;
}